module.exports = __webpack_public_path__ + "static/media/game-bosstalkingwrongexit.209e08b8.png";